export default __webpack_public_path__ + "static/media/dunno_selected.558cb602.svg";